"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorOrigin = void 0;
exports.anchorOrigin = {
    horizontal: 'right',
    vertical: 'bottom',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25hY2tiYXItY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL3NuYWNrYmFyLWNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFTYSxRQUFBLFlBQVksR0FBbUI7SUFDMUMsVUFBVSxFQUFFLE9BQU87SUFDbkIsUUFBUSxFQUFFLFFBQVE7Q0FDbkIsQ0FBQyJ9